import origins from './abilityOrigins'
import IAbilityData, { Ability } from './interfaces/IAbilityData'
import metrics from './metrics'
import { getSpecialistsByAbility } from './specialistByCategories'
import activities from './suitableActivities'

const data: IAbilityData[] = [
  {
    key: Ability.attention,
    label: 'Attention',
    description:
      'The ability to maintain concentration on a selected subject or activity, and to shift focus at will',
    metrics: [
      metrics.ContinuousPerformanceAttention,
      metrics.AttentionInhibition,
      metrics.Hyperactivity
    ],
    suitableActivities: [
      activities.Music,
      activities.MartialArts,
      activities.Baking,
      activities.Ballet
    ],
    relevantSpecialists: getSpecialistsByAbility(Ability.attention),
    origin: origins[Ability.attention]
  },
  {
    key: Ability.math,
    label: 'Math',
    description:
      'The ability to process numerical data and apply it in arithmetic calculations',
    metrics: [
      metrics.NonSymbolicNumericalRepresentation,
      metrics.SymbolicNumericalRepresentation,
      metrics.Enumeration
    ],
    suitableActivities: [
      activities.Chess,
      activities.Coding,
      activities.Science
    ],
    relevantSpecialists: getSpecialistsByAbility(Ability.math),
    origin: origins[Ability.math]
  },
  {
    key: Ability.spatial,
    label: 'Spatial',
    description:
      'The ability to grasp, process and recall spatial relations between objects',
    metrics: [metrics.SpatialAbilities],
    suitableActivities: [
      activities.Design,
      activities.Photography,
      activities.Architecture,
      activities.Engineering
    ],
    relevantSpecialists: getSpecialistsByAbility(Ability.spatial),
    origin: origins[Ability.spatial]
  },
  {
    key: Ability.motor,
    label: 'Motor',
    description:
      'The ability to control and coordinate one’s body in order to achieve desired movements with certainty and precision',
    metrics: [metrics.FineMotor, metrics.GrossMotor],
    suitableActivities: [
      activities.Dancing,
      activities.ArtsCrafts,
      activities.Music,
      activities.Sports
    ],
    relevantSpecialists: getSpecialistsByAbility(Ability.motor),
    origin: origins[Ability.motor]
  },
  {
    key: Ability.selfEsteem,
    label: 'Self-esteem',
    description:
      "The level of assurance in one's own abilities, knowledge, judgment and power",
    metrics: [metrics.Social, metrics.Emotional],
    suitableActivities: [
      activities.Acting,
      activities.Dancing,
      activities.Music,
      activities.MartialArts
    ],
    relevantSpecialists: getSpecialistsByAbility(Ability.selfEsteem),
    origin: origins[Ability.selfEsteem]
  },
  {
    key: Ability.social,
    label: 'Social',
    description:
      'The ability to navigate interpersonal interactions within clearly-defined relationships and social rules',
    metrics: [
      metrics.Prosocial,
      metrics.EmotionalSymptoms,
      metrics.ConductProblems,
      metrics.PeerProblems
    ],
    suitableActivities: [
      activities.Acting,
      activities.Directing,
      activities.Management,
      activities.Therapy
    ],
    relevantSpecialists: getSpecialistsByAbility(Ability.social),
    origin: origins[Ability.social]
  },
  {
    key: Ability.executiveFunctions,
    label: 'Flexible Thinking',
    description:
      'The ability to filter distractions, prioritize, organize, and plan tasks and actions to achieve desired goals',
    metrics: [
      metrics.Planning,
      metrics.Shifting,
      metrics.Inhibition,
      metrics.WorkingMemory
    ],
    suitableActivities: [
      activities.MartialArts,
      activities.Coding,
      activities.Science
    ],
    relevantSpecialists: getSpecialistsByAbility(Ability.executiveFunctions),
    origin: origins[Ability.executiveFunctions]
  },
  {
    key: Ability.memory,
    label: 'Memory',
    description:
      'The ability to retain and recall information and past experiences',
    metrics: [
      metrics.VisualSpatialShortTermMemory,
      metrics.VisualSpatialWorkingMemory
    ],
    suitableActivities: [
      activities.Chess,
      activities.Acting,
      activities.Music,
      activities.Science
    ],
    relevantSpecialists: getSpecialistsByAbility(Ability.memory),
    origin: origins[Ability.memory]
  },
  {
    key: Ability.language,
    label: 'Language',
    description:
      'The ability to understand and use spoken and written words to learn new information, share thoughts, feelings, and ideas, and advocate for one’s wants and needs',
    metrics: [
      metrics.Listening,
      metrics.Speaking,
      metrics.Reading,
      metrics.Writing,
      metrics.SocialEmotional
    ],
    suitableActivities: [],
    relevantSpecialists: getSpecialistsByAbility(Ability.language),
    origin: origins[Ability.language]
  }
]

export default data



// WEBPACK FOOTER //
// ./src/data/abitilies/index.ts